<template>
  <div class="app-header">
    <div class="app-header-left">
      <v-btn id="app-header-trigger-btn" text dark class="d-block d-md-none" @click="showHideMenu"><v-icon>mdi-menu</v-icon></v-btn>
    </div>
    <div class="app-header-right">
      <div class="app-header-menu">
        <v-btn text color="white" @click="switchLanguage">
          <svg-icon :icon="$i18n.locale === 'en' ? 'ic-inggris' : 'ic-indonesia'" class="mr-2" width="26" height="26" />
          {{ $i18n.locale == 'en' ? 'English' : 'Indonesia' }}
        </v-btn>
      </div>
      <div class="app-header-menu">
        <v-menu offset-y :close-on-content-click="false" bottom origin="center center" transition="scale-transition">
          <template v-slot:activator="{ on, attrs }">
            <!-- <v-btn v-bind="attrs" v-on="on" text @click="pushNotif" :color="triggerNotif ? 'red' : 'white'" class="btn-action-custom"
              ><v-icon dark>mdi-bell</v-icon></v-btn
            > -->

            <div class="text-center mr-2">
              <v-badge :content="messages" :value="messages" color="red" overlap>
                <v-hover>
                  <v-btn v-bind="attrs" v-on="on" text @click="pushNotif" :color="'white'" class="btn-action-custom"
                    ><v-icon dark>mdi-bell</v-icon></v-btn
                  >
                </v-hover>
              </v-badge>
            </div>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title>
                <div class="app-header-notification pb-0">
                  <h3>{{ $t('form.notification') }}</h3>
                  <ul>
                    <li v-for="items in notif" :key="items.notificationId">
                      <div class="icon-notif mt-2" style="fill:#edae49">
                        <svg-icon v-if="items.announcementNotification === false" icon="analytics" />
                        <svg-icon v-if="items.announcementNotification === true" icon="megaphone" />
                      </div>
                      <div class="mb-2 mt-2">
                        <strong class="notification-title">{{
                          $i18n.locale === 'en' ? items.notificationTitleEn : items.notificationTitleIdn
                        }}</strong>
                        <NotificationItemBody :item="items" />
                        <div class="notification-date mt-2">{{ items.notificationDate }}</div>
                      </div>
                    </li>
                  </ul>
                  <div v-if="!notif.length" class="mt-2">
                    <span>{{ $t('content.no_data') }}</span>
                  </div>

                  <v-btn text color="primary" v-if="$route.name !== 'StudentAssignmentScoreQuiz'" @click="toNotif" block>{{
                    $t('see_all_notifications')
                  }}</v-btn>

                  <v-btn text color="gray" v-else block>{{ $t('see_all_notifications') }}</v-btn>
                </div></v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div class="text-center">
        <v-menu offset-y :close-on-content-click="false" bottom origin="center center" transition="scale-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn text class="btn-action-custom" v-bind="attrs" v-on="on">
              <img v-if="profile.imageUrl" :src="profile.imageUrl" class="app-header-photo" />
              <img v-else :src="require('@/assets/images/sample-user.png')" class="app-header-photo" />
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-if="role === 2">
              <v-list-item-title>
                <v-btn text><svg-icon icon="clock" class="primary--text mr-3" />Time Zone</v-btn></v-list-item-title
              >
            </v-list-item>
            <v-list-item v-if="role === 2">
              <v-list-item-title
                ><v-autocomplete
                  dense
                  filled
                  rounded
                  class="pa-5"
                  v-model="timeZoneId"
                  :items="timezone"
                  item-value="timezoneId"
                  item-text="timezone"
                  @change="updateTimeZone"
                ></v-autocomplete
              ></v-list-item-title>
            </v-list-item>
            <v-list-item v-if="role === 2">
              <v-list-item-title>
                <v-select
                  :items="lang"
                  class="pa-5"
                  dense
                  filled
                  rounded
                  :label="$t('content.language')"
                  v-model="language"
                  @change="changeLanguage"
                />
              </v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>
                <v-btn text v-if="$route.name !== 'StudentAssignmentScoreQuiz'" @click.prevent="logout"
                  ><svg-icon icon="log-out" class="primary--text mr-3 " />{{ $t('logout') }}</v-btn
                >
                <v-btn text v-else><svg-icon icon="log-out" class="gray--text mr-3 " />{{ $t('logout') }}</v-btn>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <!-- <div class="app-header-menu1">
        <v-btn text class="btn-action-custom">
          <img v-if="profile.imageUrl" :src="profile.imageUrl" class="app-header-photo" />
          <img v-else :src="require('@/assets/images/sample-user.png')" class="app-header-photo" />
        </v-btn>
        <div class="app-header-menu1-content1">
          <div v-if="role === 2">
            <v-btn text style="width :300px"><svg-icon icon="clock" class="primary--text mr-3" />TimeZone</v-btn>
            <v-autocomplete
              dense
              filled
              rounded
              class="pa-5"
              v-model="timeZoneId"
              :items="timezone"
              item-value="timezoneId"
              item-text="timezone"
              @change="updateTimeZone"
            ></v-autocomplete>
          </div>
          <v-btn text @click.prevent="logout" style="width :300px"><svg-icon icon="log-out" class="primary--text mr-3 " />{{ $t('logout') }}</v-btn>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import firebase from 'firebase/app';
import 'firebase/messaging';
import socketChat from '@/plugins/socketChat';
import NotificationItemBody from './NotificationItemBody.vue';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FCM_API_KEY,
  authDomain: process.env.VUE_APP_FCM_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FCM_DATABASE_URL,
  projectId: process.env.VUE_APP_FCM_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FCM_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FCM_SENDER_ID,
  appId: process.env.VUE_APP_FCM_APP_ID
};
firebase.initializeApp(firebaseConfig);

const messaging = firebase.messaging.isSupported() ? firebase.messaging() : null;

export default {
  name: 'BaseHeader',
  components: {
    NotificationItemBody
  },
  computed: {
    ...mapGetters({
      notificationItems: 'Notification/items',
      role: 'Auth/currentRole',
      user: 'Auth/user',
      student: 'Auth/student',
      lang: 'Reference/itemLanguage'
    }),
    profile() {
      return {
        imageUrl: this.user.imageUrl,
        fullName: this.user.fullName
        // imageUrl: this.role === 3 && !!this.student ? this.student.imageUrl : this.user.imageUrl,
        // fullName: this.role === 3 && !!this.student ? this.student.fullName : this.user.fullName
      };
    }
  },
  data: () => ({
    timeZoneId: '',
    language: '',
    messages: parseInt(localStorage.getItem('notif')),
    notif: [],
    timezone: [],
    dialog: false,
    isFirstInit: true
  }),
  watch: {
    user() {
      this.setDefaultTimezone();

      if (this.user.language && this.isFirstInit) {
        this.language = this.user.language;
        this.$i18n.locale = this.user.language;
        this.localStorage.setItem('LANG', this.user.language);
        this.isFirstInit = false;
      }
    },
    timezone() {
      this.setDefaultTimezone();
    }
  },
  methods: {
    send: function() {
      this.messagesTo.push({
        content: this.messageForm.content,
        me: this.messageForm.me,
        created_at: this.messageForm.created_at
      });
      this.messageForm.content = null;
      this.addReply();
    },
    addReply() {
      this.messagesTo.push({
        content: 'oke terima kasih',
        me: false,
        created_at: this.messageForm.created_at
      });
    },
    pushNotif() {
      this.messages = 0;
      localStorage.setItem('notif', 0);
    },
    getProfile() {
      this.$store.dispatch('User/fetchProfile').then(res => {
        const timeZoneId = this.getTimeZoneId(res.gmt);
        this.timeZoneId = timeZoneId;
        this.language = res.language;
        if (res.language) {
          this.axios.defaults.headers.common['Accept-Language'] = res.language;
        } else {
          this.axios.defaults.headers.common['Accept-Language'] = 'in';
        }
      });
    },
    getNotif() {
      this.$store.dispatch('Notification/fetchData').then(res => {
        let limited = res.filter((val, i) => i < 5);

        this.notif = limited;
      });
    },
    changeLanguage() {
      let language = this.language;
      this.$store
        .dispatch('User/saveLanguage', { language })
        .then(() => {
          this.$store.dispatch('general/showSuccessNotification', { message: 'Success Change Language' });
          this.$i18n.locale = language;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    updateTimeZone() {
      let timezoneId = this.timeZoneId;
      this.$store
        .dispatch('User/saveTimeZone', { timezoneId })
        .then(() => {
          this.$store.dispatch('general/showSuccessNotification', { message: 'Success Change TimeZone' });
          this.getProfile();
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    getTimeZone() {
      this.$store
        .dispatch('User/fetchGMT')
        .then(res => (this.timezone = res))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    getNotification() {
      this.$store.dispatch('Notification/fetchList');
    },
    getTimeZoneId(tz) {
      return this.timezone.find(t => t.timezone.includes(tz))?.timezoneId;
    },
    setDefaultTimezone() {
      const id = this.getTimeZoneId(this.user.gmt);
      this.timeZoneId = id;
    },
    logout() {
      this.$store.dispatch('Auth/logout').then(() => {
        localStorage.clear();

        this.$router.push({ name: 'AuthLogin', replace: true });

        const token = 'ask_your_tech_lead';
        socketChat.auth = { token, userId: this.user.userId, username: this.user.fullName };
        socketChat.connect();

        socketChat.disconnect();
      });
    },
    iconByType(type) {
      switch (type) {
        case 'score':
          return 'popular';
        case 'submission':
          return 'legal';
      }
    },
    switchLanguage() {
      this.$i18n.locale = this.$i18n.locale == 'en' ? 'in' : 'en';
      this.axios.defaults.headers.common['Accept-Language'] = this.$i18n.locale;
      localStorage.setItem('LANG', this.$i18n.locale);
      if (this.user.roleId !== 1) {
        this.$store
          .dispatch('User/saveLanguage', { language: this.$i18n.locale })
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
      }
    },
    showHideMenu() {
      this.$root.$emit('showHideMenu');
    },
    toNotif() {
      this.$router.push({ name: 'NotifIndex' });
    }
  },
  mounted() {
    if (messaging) {
      messaging
        .requestPermission()
        .then(() => messaging.getToken())
        .then(token => {
          this.$store
            .dispatch(`User/saveToken`, { token: token, userId: this.user.userId })
            .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
        })
        .catch(err => console.log('Permission denied', err));
    }
  },
  created() {
    if (messaging) {
      messaging.onMessage(payload => {
        this.messages = parseInt(localStorage.getItem('notif')) + 1;
        localStorage.setItem('notif', this.messages);

        let datas =
          `
              ` +
          payload.notification.title +
          `
              ` +
          payload.notification.body +
          `
              `;
        this.$store.dispatch('general/showSuccessNotification', { message: datas });
        this.$store.dispatch('Notification/fetchData').then(res => {
          let limited = res.filter((val, i) => i < 5);

          this.notif = limited;
        });
      });
    }
    // if (this.role === 2) {
    // this.getProfile();
    // }
    this.getTimeZone();
    this.getNotification();
    this.getNotif();
  }
};
</script>

<style lang="scss">
.icon-notif {
  width: 24px;
  height: 24px;
  border-radius: 8px;
  background: #fff0da;
  color: #f1b65a;
  text-align: center;
  line-height: 24px;
  margin-right: 12px;

  svg {
    margin-top: 3px;
  }
}
.app-header {
  display: flex;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #fff;
  color: #fff;
  justify-content: space-between;

  &-childparent {
    border-radius: 8px;
    box-shadow: 0 7px 16px 0 rgba(237, 174, 73, 0.13);
    width: 170px;
    height: 38px;
  }
  &-childtext {
    color: #ffffff;
    font-size: 12px;
    line-height: 14.63px;
    text-align: left;
  }
  &-photo {
    width: 30px;
    height: 30px;
    overflow: hidden;
    border-radius: 100px;
    border: 2px solid #fff;
    object-fit: cover;
  }

  &-childfoto {
    background-size: 100%;
    border: 2px solid #ffffff;
    border-radius: 8px;
    width: 18px;
    height: 18px;
    margin-bottom: -3.5px;
    margin-right: 3px;
  }

  &-childtextdalem {
    color: #0f0f0f;
    font-family: Montserrat;
    font-size: 12px;
    line-height: 14.63px;
    text-align: left;
  }

  &-childtextl {
    color: #838a8a;
    font-family: Montserrat;
    font-size: 12px;
    line-height: 14.63px;
    text-align: left;
  }

  &-right {
    display: flex;
    align-items: center;

    > * {
      margin-left: 5px;
    }
  }

  &-menu {
    position: relative;
    z-index: 100;

    &:hover {
      .app-header-menu-content {
        transform: translateY(0);
        visibility: visible;
        opacity: 1;
      }
    }

    &-content {
      position: absolute;
      right: 0;
      background: #fff;
      border-radius: 4px;
      box-shadow: 0 7px 16px 0 rgba(0, 0, 0, 0.13);
      transform: translateY(40px);
      visibility: hidden;
      width: 300px;
      opacity: 0;
      backface-visibility: hidden;
      transition: all 300ms cubic-bezier(0.455, 0.03, 0.515, 0.955);
    }
  }

  // &-menu1 {
  //   position: relative;
  //   z-index: 100;

  //   &:hover {
  //     .app-header-menu1-content1 {
  //       transform: translateY(0);
  //       visibility: visible;
  //       opacity: 1;
  //     }
  //   }

  //   &-content1 {
  //     position: absolute;
  //     right: 0;
  //     background: #fff;
  //     border-radius: 4px;
  //     box-shadow: 0 7px 16px 0 rgba(0, 0, 0, 0.13);
  //     transform: translateY(40px);
  //     visibility: hidden;
  //     width: 300px;
  //     opacity: 0;
  //     backface-visibility: hidden;
  //     transition: all 300ms cubic-bezier(0.455, 0.03, 0.515, 0.955);
  //   }
  // }

  &-childdrop {
    width: 180px;
    color: #6d6d6d;
    padding: 10px;

    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        display: flex;
        padding: 10px 0;
        margin-bottom: -15px;
        border-bottom: 1px dashed #acacac;
      }
    }
  }

  &-notification {
    width: 275px;
    color: #6d6d6d;
    padding: 12px;

    h3 {
      font-weight: 800;
      border-bottom: 1px dashed #acacac;
      padding-bottom: 12px;
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        display: flex;
        padding: 10px 0;
        border-bottom: 1px dashed #acacac;
      }
    }

    .notification {
      &-content {
        flex-basis: 100%;
      }

      &-message {
        font-size: 12px;
      }
    }
  }
}

.notification-title {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
.notification-body {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 10px;
  line-height: 16px;
  width: 224px;
  text-align: left;
}

.notification-date {
  color: #ce8800;
  font-family: Montserrat;
  font-size: 10px;
  line-height: 12px;
  text-align: left;
}
</style>
